// 入学时间 开班时间等起始年份
const startYear = 2017

// 年份
function initYear() {
  const nowYear = new Date().getFullYear()
  const yearDiffer = nowYear - startYear + 1
  let yearList = []

  for (let index = 0; index < yearDiffer; index++) {
    yearList.push(`${startYear + index}`)
  }
  return yearList
}

// 起始年份
function initEnrollmentYear() {
  const nowYear = new Date().getFullYear()
  const yearDiffer = nowYear - startYear + 1

  let enrollmentYearList = []

  for (let index = 0; index < yearDiffer; index++) {
    enrollmentYearList.push(`${startYear + index} Spring`)
    enrollmentYearList.push(`${startYear + index} Autumn`)
  }
  return enrollmentYearList
}

// 学年
function initAcademicYear() {
  const nowYear = new Date().getFullYear()
  const nowMonth = new Date().getMonth() + 1

  let yearDiffer = 0
  if (nowMonth > 6) {
    yearDiffer = nowYear - startYear + 1
  } else {
    yearDiffer = nowYear - startYear
  }

  let academicYearList = []

  for (let index = 0; index < yearDiffer; index++) {
    academicYearList.push(`${startYear + index}/${startYear + index + 1}`)
  }

  return academicYearList
}

const dataManage = {
  state: {
    systemName: 'Home Page',
    localeLanguage: 'zh-CN',
    pageSize: 50, //表格每页数据
    formatDate: 'YYYY-MM-DD', //日期格式化
    formatTime: 'YYYY-MM-DD HH:mm:ss', //时间格式化
    yearList: initYear(), //年
    enrollmentYearList: initEnrollmentYear(), //上学起始年份
    academicYearList: initAcademicYear(), //学年
    classStatusList: [
      { value: 0, label: 'public.archive' },
      { value: 1, label: 'public.active' },
    ], //班级状态
    classTypeList: [
      { value: 'Archived', label: 'public.archive' },
      { value: 9, label: 'public.pre10' },
      { value: 10, label: 'public.10' },
      { value: 11, label: 'public.11' },
      { value: 12, label: 'public.12' },
    ], //班级类型
    genderList: ['male', 'female'],
    examList: [
      { value: 1, label: '1st Semester Mid Term' },
      { value: 2, label: '1st Semester Final' },
      { value: 3, label: '2nd Semester Mid Term' },
      { value: 4, label: '2nd Semester Final' },
    ], //考试
    // 学期
    semesterList: [
      { value: 1, label: '1st Semester' },
      { value: 2, label: '2nd Semester' },
    ],
    gradeList: [
      { value: '9', label: 'Pre-10' },
      { value: '10', label: '10' },
      { value: '11', label: '11' },
      { value: '12', label: '12' },
    ], //年级
    currentGradeList: [
      { value: 'active', label: 'public.active' },
      { value: 'graduated', label: 'public.graduated' },
      { value: 'suspension', label: 'public.suspension' },
      { value: 'dropout', label: 'public.dropout' },
      { value: '9', label: 'public.pre10' },
      { value: '10', label: 'public.10' },
      { value: '11', label: 'public.11' },
      { value: '12', label: 'public.12' },
    ], //学生年级状态
    //权限适应人群
    applicableObject: [
      {
        key: 1,
        label: 'staff.allStudent',
      },
      {
        key: 2,
        label: 'staff.relatedStudent',
      },
    ],
    classTypeData: [
      {
        name: 'class.administrativeClass',
        id: 1,
      },
      {
        name: 'class.electiveClass',
        id: 2,
      },
    ],
    courseSelect: [
      {
        label: 'staff.science',
        key: 1,
      },
      {
        label: 'staff.english',
        key: 2,
      },
      {
        label: 'staff.liberalArts',
        key: 3,
      },
      {
        label: 'staff.arts',
        key: 4,
      },
      {
        label: 'staff.music',
        key: 5,
      },
      {
        label: 'staff.drama',
        key: 6,
      },
      {
        label: 'staff.PE',
        key: 7,
      },
      {
        label: 'staff.club',
        key: 8,
      },
    ],
    courseSelectObj: {
      1: 'staff.science',
      2: 'staff.english',
      3: 'staff.liberalArts',
      4: 'staff.arts',
      5: 'staff.music',
      6: 'staff.drama',
      7: 'staff.PE',
      8: 'staff.club',
    },
    statisticsStatus: undefined,
    currentAcademicYear: undefined,
    currentSemerter: undefined,
    studentMajorOption: [
      {
        name: 'A Level',
      },
      {
        name: 'Art & Design',
      },
      {
        name: 'Music & Drama',
      },
    ],
  },

  mutations: {
    SET_SYSTEMNAME(state, systemName) {
      state.systemName = systemName
    },
    SET_LOCALELANGUAGE(state, localeLanguage) {
      state.localeLanguage = localeLanguage
    },
    setStatisticsStatus(state, status) {
      state.statisticsStatus = status
    },
    setCurrentAcademicYear(state, status) {
      state.currentAcademicYear = status
    },
    setCurrentSemerter(state, status) {
      state.currentSemerter = status
    },
  },
}

export default dataManage
